<template>
  <v-container fluid>
    <v-row class="common-card-row">
      <v-col class="common-card-col">
        <v-row no-gutters>
          <v-col cols="12" sm="4" class="text-h6 pt-1 titleLight--text"> Devices Overview </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="4" lg="2">
            <InputSelectVT
              height="32"
              :items="page_content.devices_overview_select"
              @value_changes="get_device_overview($event)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="common-card-row">
      <v-col class="pa-0 pb-3 pr-md-3 pb-md-0" cols="12" md="4">
        <v-col class="common-card-col">
          <RadialChartVT
            :title="page_content.battery_status.title"
            :chartData="battery_status_data"
            @on-click="apply_battery_filter($event)"
          />
        </v-col>
      </v-col>
      <v-col class="pa-0 pb-3 pr-md-3 pb-md-0" cols="12" md="4">
        <v-col class="common-card-col">
          <RadialChartVT
            :title="page_content.connection_status.title"
            :chartData="connection_status_data"
            @on-click="apply_comm_filter($event)"
          />
        </v-col>
      </v-col>
      <v-col class="pa-0 pb-3 pb-md-0" cols="12" md="4">
        <v-col class="common-card-col">
          <RadialChartVT
            :title="page_content.message_type.title"
            :chartData="message_type_data"
            @on-click="apply_message_filter($event)"
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="common-card-row pb-3">
      <v-col class="common-card-col">
        <v-row>
          <v-col cols="8" sm="10">
            <PrimaryFiltersVT
              :list_filters="page_content.filters.primary"
              @filter_update="filter_list($event)"
              :current_tab="current_tab"
            ></PrimaryFiltersVT>
          </v-col>
          <v-col cols="4" sm="2" class="text-right">
            <SecondaryFiltersVT
              v-if="current_tab != 'BackOnline'"
              :multiple="multiple"
              :filters="page_content.filters.secondary"
              @clear_filters="clear_filters"
              @apply_filters="apply_filters($event)"
            ></SecondaryFiltersVT>
          </v-col>
        </v-row>
        <DataTableVT
          v-if="current_tab != 'BackOnline'"
          :headers="page_content.devices_table"
          :items_list="devices"
          item_key="DeviceID"
          @rowClick="open_details($event)"
          @add-to-list="watchlist_update($event)"
          :loading="is_loading"
        />
        <DataTableVT
          v-else
          :headers="page_content.devices_back_online_table"
          :items_list="devices_back_online"
          item_key="DeviceID"
          @rowClick="open_details($event)"
          :loading="is_loading"
        />
      </v-col>
    </v-row>
    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        class="backgroundLight"
        style="width: 80vw; max-height: 80vh; overflow: auto"
      >
        <div class="close-btn">
          <v-btn right @click="closeDialog" outlined color="primaryGrey" class="py-4" x-small>
            <v-icon small color="primaryGrey">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="pa-0" style="overflow: auto; height: 100%">
          <Device :deviceId="deviceId" />
        </div>
      </v-card>
    </v-overlay>
  </v-container>
</template>

<script>
import Device from "../views/Device";
import DataTableVT from "../components/DataTableVT";
import RadialChartVT from "../components/RadialChartVT";
import InputSelectVT from "../components/InputSelectVT";
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import SecondaryFiltersVT from "../components/SecondaryFiltersVT";
import { axios_get, axios_post, axios_delete } from "../services/vt_service";
import { tracking } from "../services/tracking";
import { watchlist } from "../services/common";
import { content } from "../../config/devices.js";
import { redirect_to_asset } from "../helpers/helpers";

export default {
  name: "DeviceHome",
  components: {
    Device,
    DataTableVT,
    RadialChartVT,
    InputSelectVT,
    PrimaryFiltersVT,
    SecondaryFiltersVT,
  },
  watch: {
    devices_data: function (newVal) {
      if (newVal) {
        this.is_loading = true;
        this.get_device_overview("1");
        this.get_device_list();
      }
    },
  },
  data: function () {
    return {
      filter_conditions: {},
      flags: {},
      multiple_conditions: {},
      current_tab: "All",
      deviceId: null,
      dialog: false,
      search: "",
      page_content: null,
      network_error: false,
      devices: [],
      error_message: "",
      items: ["Today", "This Week", "This Month"],
      devices_overview_data: null,
      watchlist: [],
      filter_communicated: "",
      filter_others: false,
      multiple: true,
      is_loading: true,
      devices_back_online: [],
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    this.is_loading = true;
    if (this.$route.params && Object.keys(this.$route.params).indexOf("search") != -1) {
      window.setTimeout(() => {
        this.apply_outside_filter();
      }, 500);
    }
    if (this.devices_data) {
      this.get_device_overview("1");
      this.get_device_list();
    }
    // this.$store.commit("update_page_title", "Devices");
  },
  filters: {},
  methods: {
    closeDialog() {
      this.dialog = false;
      this.deviceId = null;
    },
    async get_devices_back_online() {
      if (this.devices_back_online.length > 0) return;
      const response = await axios_get(tracking.get_devices_back_online);
      this.devices_back_online = response;
    },
    apply_battery_filter(val) {
      this.filter_conditions["BatteryStatus"] = val.split(" ")[0];
      this.filter_list("All");
    },
    apply_comm_filter(val) {
      this.filter_communicated = val;
      this.filter_list("All");
    },
    apply_message_filter(val) {
      if (val == "Others") {
        this.filter_others = true;
      } else {
        this.filter_others = false;
        this.filter_conditions["LastMessageType"] = val;
      }
      this.filter_list("All");
    },
    apply_outside_filter() {
      let filter = {
        checkbox: {
          LocationType: ["No location data", "Outside POIs"],
        },
      };
      this.multiple_conditions = filter.checkbox;
      this.filter_list("All");
    },
    apply_filters: function (filters) {
      this.multiple_conditions = filters.checkbox;
      this.flags = filters.flags;
      this.filter_list("All");
    },
    clear_filters: function () {
      this.filter_conditions = {};
      this.multiple_conditions = {};
      this.flags = {};
      this.filter_list("All");
    },
    batteryIndicator(batteryStatus) {
      return batteryStatus == "High"
        ? "success--text"
        : batteryStatus == "Medium"
        ? "secondary--text"
        : batteryStatus == "Low"
        ? "error--text"
        : "primarGrey--text";
    },
    open_details(item) {
      if (item.ctrlKey) return redirect_to_asset(this.$router, "device", item.DeviceID);
      this.deviceId = item.DeviceID;
      this.dialog = true;
    },
    watchlist_update(item) {
      item["IsWatchlisted"] ? this.delete_from_watchlist(item) : this.add_to_watchlist(item);
    },
    async filter_list(filter) {
      if (this.current_tab == filter) return;
      this.is_loading = true;
      if (filter) this.current_tab = filter;
      if (filter == "BackOnline") {
        await this.get_devices_back_online();
        this.is_loading = false;
        return;
      }
      var params = {};
      const keys = Object.keys(this.filter_conditions);
      keys.forEach((key) => {
        if (this.filter_conditions[key]) params[key] = this.filter_conditions[key].toString();
      });
      var fil = this.page_content.filters.primary.filter((elem) => {
        return elem.value == filter;
      });
      fil = fil && fil.length == 1 ? fil.map((e) => e.value) : null;
      this.network_error = false;
      let response =
        Object.keys(params).length != 0 ? await axios_get(tracking.get_device_list, {}, params) : this.devices_data;
      let other_message_types = ["twowifi", "gps", "onewifi", "none"];
      this.devices = response
        .map((elem) => {
          elem.IsWatchlisted = this.watchlist.indexOf(elem.DeviceID) != -1 ? true : false;
          return elem;
        })
        .filter((elem) => {
          return (fil.indexOf("Watchlist") != -1 && elem.IsWatchlisted == true) || fil.indexOf("All") != -1;
        })
        .filter((elem) => {
          let filtered = true;
          Object.keys(this.flags).forEach((key) => {
            if (this.flags[key]) {
              filtered = filtered && elem[key];
            }
          });
          return filtered;
        })
        .filter((elem) => {
          let filtered = true;
          Object.keys(this.multiple_conditions).forEach((key) => {
            if (typeof this.multiple_conditions[key] == "string") {
              filtered = filtered && elem[key] == this.multiple_conditions[key];
            } else if (this.multiple_conditions[key].length > 0) {
              let fil = false;
              this.multiple_conditions[key].forEach((el) => {
                fil = fil || (elem[key] && elem[key].toLowerCase().trim() == el.toLowerCase().trim());
              });

              filtered = filtered && fil;
            }
          });
          return filtered;
        })
        .filter((elem) => {
          let last_message_time = elem.LastMessageTime && new Date(elem.LastMessageTime);
          let today = new Date();
          let delta = Math.abs(today - last_message_time) / 1000;
          let hours = delta / 3600;
          return (
            (this.filter_communicated && this.filter_communicated.toLowerCase().includes("no") && hours >= 72) ||
            (this.filter_communicated && !this.filter_communicated.toLowerCase().includes("no") && hours < 72) ||
            (this.filter_others &&
              other_message_types.indexOf(elem.LastMessageType ? elem.LastMessageType.toLowerCase() : "") == -1) ||
            (!this.filter_communicated && !this.filter_others && true)
          );
        });
      this.is_loading = false;
    },
    async add_to_watchlist(item) {
      var data = { DeviceID: item["DeviceID"] };
      this.network_error = false;
      await axios_post(watchlist.add_to_watchlist, data);
      item["IsWatchlisted"] = true;
      this.watchlist.push(item["DeviceID"]);
    },
    async delete_from_watchlist(item) {
      var data = { DeviceID: item["DeviceID"] };
      this.network_error = false;
      await axios_delete(watchlist.delete_from_watchlist, {}, data);
      this.watchlist.splice(this.watchlist.indexOf(item["DeviceID"]), 1);
      item["IsWatchlisted"] = false;
    },
    async get_device_overview(duration) {
      this.network_error = false;
      this.network_error = false;
      const response = await axios_get(tracking.get_device_overview, { duration });
      this.devices_overview_data = response;
    },
    async get_device_list() {
      const response = await axios_get(watchlist.get_device_watchlist);
      let temp = JSON.parse(JSON.stringify(this.devices_data));
      this.watchlist =
        response &&
        response.map((elem) => {
          return elem["DeviceID"];
        });
      this.devices = temp.map((elem) => {
        elem.IsWatchlisted = this.watchlist.indexOf(elem.DeviceID) != -1 ? true : false;
        return elem;
      });
      this.is_loading = false;
    },
    format_chart_data(chart_data, config) {
      var data = [];
      var others_total = 0;
      if (chart_data) {
        data = config.data.map((currentValue) => {
          others_total = 0;
          var total = 0;
          var result = chart_data.filter((data) => {
            total = total + data.Total;
            if (
              data.name &&
              !currentValue.values &&
              data.name.toLowerCase().trim() == currentValue.value.toLowerCase().trim()
            ) {
              return true;
            } else if (data.name && !currentValue.value && currentValue.values) {
              others_total =
                others_total +
                (data.name && currentValue.values.indexOf(data.name.toLowerCase()) == -1 ? data.Total : 0);
              return true;
            } else {
              return false;
            }
          });
          var value = result[0] && result[0]["Total"];
          var final_val = currentValue.label == "Others" ? others_total : value;
          return [
            currentValue.label,
            final_val,
            {
              msg: currentValue.msg,
              title: currentValue.label,
              footer: `${this.$numberWithCommas(final_val)}(${this.$numberWithCommas(
                Math.round((final_val / total) * 10000) / 100
              )}%)`,
            },
          ];
        });
      } else {
        data = [config.header];
      }
      return [config.header, ...data];
    },
  },
  computed: {
    user_account: function () {
      return this.$auth.user;
    },
    battery_status_data: function () {
      return this.devices_overview_data
        ? this.format_chart_data(this.devices_overview_data.batteryStatus, this.page_content.battery_status)
        : [];
    },
    connection_status_data: function () {
      return this.devices_overview_data
        ? this.format_chart_data(this.devices_overview_data.connectionStatus, this.page_content.connection_status)
        : [];
    },
    message_type_data: function () {
      return this.devices_overview_data
        ? this.format_chart_data(this.devices_overview_data.messageType, this.page_content.message_type)
        : [];
    },
    devices_data: function () {
      return this.$store.state.devices ? JSON.parse(JSON.stringify(this.$store.state.devices)) : null;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .right-border {
  border-right: 1px solid var(--v-border-base);
}
::v-deep .fxd-height {
  min-height: 50px;
  align-items: flex-start;
}
.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}
</style>
